"use strict";
exports.__esModule = true;
var angular = require("angular");
var ZONE_COLORS = {
    'DISCOVERY': '#ffcce469',
    'SPECIFY': '#ffffb3F0',
    'NAVIGATE': '#a0c5f899',
    'MANAGE': '#b3ffe4A0'
};
function makeIssueZoneAndColor(ignorance, impact) {
    var issueColor = ZONE_COLORS.MANAGE;
    var issueZone = 'Manage';
    if (ignorance >= 5 && impact >= 5) {
        issueColor = ZONE_COLORS.DISCOVERY;
        issueZone = 'Discovery';
    }
    else if (ignorance >= 5 && impact < 5) {
        issueColor = ZONE_COLORS.SPECIFY;
        issueZone = 'Specify';
    }
    else if (ignorance < 5 && impact >= 5) {
        issueColor = ZONE_COLORS.NAVIGATE;
        issueZone = 'Navigate';
    }
    return { 'issueZone': issueZone, 'issueColor': issueColor };
}
function formatIssueData(item, isQualitative) {
    var issueZoneDetails = makeIssueZoneAndColor(item.ignorance, item.impact);
    var impactToBeUsed = isQualitative ? item.impact : item.calcImpact;
    return {
        name: item.name,
        ignorance: item.ignorance,
        impact: impactToBeUsed,
        score: item.ignorance * impactToBeUsed,
        issueZone: issueZoneDetails['issueZone'],
        issueColor: issueZoneDetails['issueColor'],
        issueDescription: 'issueDescription' in item ? item.issueDescription : undefined,
        issueFactor: 'issueFactor' in item ? item.issueFactor : undefined
    };
}
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent($rootScope, $scope, $timeout) {
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.$scope = $scope;
        $scope.$on('command:DASHBOARD', function (event, args) {
            ctrl.initComponent(event, args);
            $scope.$emit('workbench:loading', { 'load': false });
        });
        $scope.$on('command:READINESS', function (event, args) {
            ctrl.initComponent(event, args);
            $scope.$emit('workbench:loading', { 'load': false });
        });
    }
    DashboardComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.isQualitative = false;
        if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        }
        ctrl.showTextField = false;
        ctrl.getIssueDetailsFromDb();
        ctrl.menu = [];
    };
    DashboardComponent.prototype.getIssueDetailsFromDb = function () {
        var ctrl = this;
        ctrl.smartorg.getInavIssueData(ctrl.node['_id']).then(function (res) {
            if (res.status == 1) {
                // ctrl.showAlert('danger', 'Error!', res.message);
                ctrl.issueData = [{
                        issueColor: "", name: "Issues", score: 0
                    }];
                ctrl.drawReadinessChart();
                ctrl.drawBarChart();
            }
            else {
                if (res.length == 0) {
                    ctrl.showTextField = false;
                    ctrl.showAlert('warning', 'Warning!', 'No issues found. Create issues first.');
                }
                else if (!('score' in res[0])) {
                    ctrl.showTextField = false;
                    ctrl.showAlert('warning', 'Warning!', 'Save required details in Experiment Management');
                }
                else {
                    ctrl.issueData = res.map(function (item) { return formatIssueData(item, ctrl.isQualitative); });
                    ctrl.issueData.sort(function (a, b) { return (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0); });
                    ctrl.drawReadinessChart();
                    ctrl.drawBarChart();
                }
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', 'Cannot get issue data' + err.message);
        });
    };
    DashboardComponent.prototype.saveDashboardData = function () {
        var ctrl = this;
        ctrl.smartorg.saveInavDashboardData(ctrl.node['_id'], ctrl.summary, ctrl.recommendation).then(function (res) {
            if (res) {
                ctrl.showAlert('success', 'Success!', 'Summary and Recommendation are saved.');
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    DashboardComponent.prototype.makeReadinessSeries = function () {
        var ctrl = this;
        var series = [];
        ctrl.cumulativeScore = 0;
        ctrl.issueData.forEach(function (data) {
            ctrl.cumulativeScore += data['score'];
            var issueZoneDetails = makeIssueZoneAndColor(data['ignorance'], data['impact']);
            series.push({
                name: data['name'],
                data: [data['score']],
                color: issueZoneDetails['issueColor']
            });
        });
        return series;
    };
    DashboardComponent.prototype.drawReadinessChart = function () {
        var ctrl = this;
        ctrl.readinessSeries = ctrl.makeReadinessSeries();
        ctrl.category = '';
        Highcharts.chart('readinessChartContainer', {
            chart: {
                type: 'column',
                zoomType: 'xy'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Project Surprise Index'
            },
            subtitle: {
                text: 'Communicate total discovery content of project by total surprise index in stacked bar graph of issues'
            },
            xAxis: {
                categories: [ctrl.category]
            },
            yAxis: {
                min: 0,
                max: ctrl.cumulativeScore,
                title: {
                    text: ''
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: ( // theme
                        Highcharts.defaultOptions.title.style &&
                            Highcharts.defaultOptions.title.style.color) || 'gray'
                    }
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
                crosshairs: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false
                    },
                    borderWidth: 0
                }
            },
            series: ctrl.readinessSeries
        });
    };
    DashboardComponent.prototype.makeBarSeries = function () {
        var ctrl = this;
        var series = [];
        ctrl.issueData.forEach(function (data) {
            // if (data['includeInSprint']) {
            var issueZoneDetails = makeIssueZoneAndColor(data['ignorance'], data['impact']);
            series.push({
                name: data['name'],
                y: data['score'],
                color: issueZoneDetails['issueColor']
            });
            // }
        });
        return series;
    };
    DashboardComponent.prototype.drawBarChart = function () {
        var ctrl = this;
        ctrl.barSeries = ctrl.makeBarSeries();
        Highcharts.chart('barChartContainer', {
            chart: {
                type: 'column',
                zoomType: 'xy'
            },
            credits: {
                enabled: false
            },
            title: {
                text: 'Surprise Index by Issue'
            },
            subtitle: {
                text: 'Focus on high surprise index (discovery) issues'
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                title: {
                    text: ''
                }
            },
            legend: {
                enabled: false
            },
            tooltip: {
                pointFormat: '<b>{point.y}</b>',
                crosshairs: true
            },
            series: [{
                    data: ctrl.barSeries
                }]
        });
    };
    return DashboardComponent;
}());
angular.module('smartorg.r6.acts.dashboard', []).component('dashboard', {
    template: require('./dashboard.component.html'),
    controller: DashboardComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.dashboard';
//# sourceMappingURL=dashboard.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/dashboard/dashboard.component.js